import * as React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Scrollbars } from "react-custom-scrollbars";
import Select, { createFilter }  from 'react-select';

import { toggleModal } from "../../actions/modalActions";
import { getDevices } from "../../actions/deviceActions";
import { setCurrentArea, addAreaDevice, removeAreaDevice, getArea, getAreas } from "../../actions/areaActions";

import Modal from "./Modal";

class AreaDeviceListModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            device: {},
            deviceError: "",
            devicesLabel: [],
        };
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.areaId &&
            (this.props.areaId !== prevProps.areaId ||
                (!this.props.devicesLoading && prevProps.devicesLoading))
        ) {
            this.props.getArea(this.props.areaId);

            const devicesLabel = this.props.devices.map(device => ({
                value: device.id,
                label: device.city + ", " + device.address,
            }))

            this.setState({
                devicesLabel: devicesLabel,
            })
        }
    }

    onClose = () => {
        this.setState({
            device: ""
        });
        this.props.getAreas();
        this.props.toggleModal("AreaDeviceListModal");
        this.props.setCurrentArea(null);
    };

    onDeviceAdd = () => {
        const { device } = this.state;
        const { areaDevices } = this.props;

        if (!device) {
            return;
        }

        if (areaDevices && areaDevices.filter(item => item.id === device.value).length !== 0) {
            return this.setState({
                deviceError: "dashboard.modals.area.device.error.added"
            });
        }

        this.props
            .addAreaDevice(this.props.areaId, device.value)
            .then(() => this.props.getArea(this.props.areaId));

        this.setState({
            device: "",
            deviceError: ""
        });
    };

    onDeviceChange = selectedOption => {
        this.setState({ device: selectedOption });
    };

    removeDevice(areaId, deviceId) {
        this.props.removeAreaDevice(areaId, deviceId).then(() => this.props.getArea(areaId));
    }

    renderItems() {
        const { areaDevices, CurrentAreaError, areaId } = this.props;

        if (CurrentAreaError || !areaDevices || areaDevices.length === 0) {
            return;
        }

        return (
            <ul className="simple-list">
                {areaDevices.map(item => {
                    return (
                        <li className="my-3" key={item.id}>
                            <div className="d-flex justify-content-between align-content-center">
                                <span>{item.city + ", " + item.address}</span>
                                <i
                                    className="fa fa-trash action-icon"
                                    onClick={() => this.removeDevice(areaId, item.id)}
                                />
                            </div>
                        </li>
                    );
                })}
            </ul>
        );
    }

    render() {
        const { deviceError } = this.state;

        const { modals, deviceId, areaName, CurrentAreaError } = this.props;

        if (CurrentAreaError) {
            return null;
        }

        const show = modals.includes("AreaDeviceListModal");

        return (
            <Modal show={show} title={areaName} onClose={this.onClose}>
                {deviceError && (
                    <div className="invalid-feedback d-block mb-4">
                        <FormattedMessage id={deviceError} />
                    </div>
                )}
                <div className="d-flex justify-content-between mt-3 mb-2">
                    <Select
                        value={this.state.device}
                        onChange={this.onDeviceChange}
                        options={this.state.devicesLabel}
                        className="react-select-container"
                        id={deviceId}
                        filterOption={createFilter({ignoreAccents: false})}
                        theme={theme => ({
                            ...theme,
                            borderRadius: 0,
                            colors: {
                              ...theme.colors,
                              primary: '#607d8b',
                            },
                          })}
                    />
                    <button
                        type="button"
                        className="btn btn-primary btn--fixed-width ml-4"
                        onClick={this.onDeviceAdd}
                    >
                        <FormattedMessage id="dashboard.modals.area.device.add" />
                    </button>
                </div>
                <hr />
                <p className="pt-2 mb-0">
                    <strong>
                        <FormattedMessage id="dashboard.modals.area.header" />
                    </strong>
                </p>
                <Scrollbars style={{ height: "250px" }}>
                    {this.renderItems()}
                </Scrollbars>
            </Modal>
        );
    }
}

export default connect(
    state => ({
        devices: state.device.data.list,
        areas: state.area.data.list,
        areaId: state.area.current,
        areaName: state.area.currentArea.data.name,
        modals: state.modals,
        areaDevices: state.area.currentArea.data.devices,
        CurrentAreaError: state.area.currentArea.error,
        devicesLoading: state.device.data.loading,
        areaLoading: state.area.currentArea.loading
    }),
    {
        toggleModal,
        getDevices,
        setCurrentArea,
        addAreaDevice,
        removeAreaDevice,
        getArea,
        getAreas,
    }
)(AreaDeviceListModal);



// WEBPACK FOOTER //
// ./src/components/Modal/AreaDeviceListModal.js